import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';

import Layout from 'app/layouts/Layout';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import UserContext from './context/UserContext';
import useUser from './hooks/useUser';
import 'app/helpers/initFA';

const App = () => {
  const { user, addUser, removeUser } = useUser();

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <UserContext.Provider
        value={{ user: user, setUser: addUser, removeUser: removeUser }}
      >
        <Layout />
      </UserContext.Provider>
    </Router>
  );
};

export default App;
